// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconCollapse = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path fill='currentcolor' d='M21 7H9z' />
        <path stroke='currentcolor' strokeLinecap='round' strokeWidth={2} d='M21 7H9M21 12H9M21 17H9' />
        <path
            fill='currentcolor'
            fillRule='evenodd'
            d='M4.319 13.803a.5.5 0 0 0 .853-.353v-3.243a.5.5 0 0 0-.853-.354l-1.622 1.622a.5.5 0 0 0 0 .707z'
            clipRule='evenodd'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconCollapse)
const Memo = memo(ForwardRef)
export default Memo
